import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

var circularProgressTheme = createTheme(shippoTheme, {
    palette: {
        primary: {
            main: colors.accent.foreground.success,
            dark: colors.primaryButtonHover,
        },
        secondary: {
            main: colors.secondary,
            dark: colors.secondary,
        },
    },
});

export { circularProgressTheme as default };
//# sourceMappingURL=CircularProgress.theme.js.map
